import React from 'react';
import ScheduleAreaContainer from './subcomponents/ScheduleArea';

const Schedule = () => (
    <ScheduleAreaContainer />
);

export default Schedule;
